<div class="sm-flex sm-flex-col sm-gap-y-2">
  <div class="sm-flex sm-flex-col sm-gap-y-2">
    <span>List source:</span>
    <div data-test="list-name" class="sm-w-full sm-rounded sm-bg-grey-1 sm-border-2 sm-border-grey-3 sm-p-2">
      {{ listName }}
    </div>
  </div>
  <div data-test="column-name" class="sm-flex sm-flex-col sm-gap-y-2">
    <span>Referenced Column:</span>
    <div class="sm-w-full sm-rounded sm-bg-grey-1 sm-border-2 sm-border-grey-3 sm-p-2">
      {{ referenceColumn.heading }}
    </div>
  </div>
  <div class="sm-flex sm-flex-col sm-gap-y-2">
    <span>List Property:</span>
    <ng-select
      [(ngModel)]="cellData.content.propertyId"
      appendTo="body"
      placeholder="Select list property"
      i18n-placeholder="Select list property"
      [items]="listProperties"
      bindValue="_id"
      bindLabel="name"
      (change)="onSelectItem($event)"
    >
      <ng-template ng-option-tmp let-item="item">
        <ng-container *ngIf="item.kind !== ListEntryTypes.Attachment; else attachmentOption">
          <span>{{ item.name }}</span>
        </ng-container>
        <ng-template #attachmentOption>
          <cc-popover placement="right" container="body">
            <span i18n content>
              Attachment properties are not yet supported in List property table cells.
            </span>
            <div trigger class="sm-flex sm-flex-row sm-items-center sm-gap-x-1">
              <span class="sm-cursor-not-allowed">{{ item.name }}</span>
              <i class="cc-icon cc-icon-question" aria-hidden="true"></i>
            </div>
          </cc-popover>
        </ng-template>
      </ng-template>
    </ng-select>
    <span *ngIf="selectedPropertyType" class="sm-text-secondary-text sm-text-xs">
      List Property type: {{ selectedPropertyType }}
    </span>

    <a [href]="articleLink" target="_blank" class="button-learn-more">
      <em class="cc-icon cc-icon-question" aria-hidden="true"></em>
      <span i18n>Learn more </span>
    </a>
  </div>
</div>
